const { formatText } = require('core/i18n').i18n;

const {
    MULTIPLE_QUOTA_TAG,
    MULTIPLE_QUOTA,
    ONE_QUOTA_TAG,
    ONE_QUOTA,
    THREE_QUOTA_TAG,
    THREE_QUOTA,
    PAY_LATER,
    TAE,
    TIN,
} = require('constants/lavanda');

const getNumberOfQuotas = (value) => {
    if (value === ONE_QUOTA) {
        return 1;
    } else if (value === THREE_QUOTA){
        return 3;
    } else if (value === MULTIPLE_QUOTA){
        return 4;
    } else{
        return 0;
    }
}

const getChosenDeferralText = (option) => {
    switch (option) {
        case ONE_QUOTA:
            return formatText('lavanda-lavanda_chosenDeferral1');
        case THREE_QUOTA:
            return formatText('lavanda-lavanda_chosenDeferral2');
        case MULTIPLE_QUOTA:
            return formatText('lavanda-lavanda_chosenDeferral3');
        default:
            return '-'
    }
}

const getDeferralMonthsText = (number) => {
    let deferralMonthsKey = '-';

    if (number === 1){
        deferralMonthsKey = formatText('lavanda-lavanda_deferralOneMonth');
    } else if (number > 1) {
        deferralMonthsKey = formatText('lavanda-lavanda_deferralMultipleMonths', [number]) ;
    }
    
    return deferralMonthsKey;
}

const isLavandaCard = (product, lavandaCards) => {
    return lavandaCards.includes(product);
}

const getDeferralOptionTag = (value) => {
    if (value === ONE_QUOTA) {
        return ONE_QUOTA_TAG;
    } else if (value === THREE_QUOTA){
        return THREE_QUOTA_TAG;
    } else if (value === MULTIPLE_QUOTA){
        return MULTIPLE_QUOTA_TAG;
    } else{
        return '';
    }
}

const getChosenDeferralTag = (number) => {
    let deferralMonthsKey = '';

    if (number === 1){
        deferralMonthsKey = ONE_QUOTA_TAG;
    } else if (number > 1) {
        deferralMonthsKey = `${number} meses`;
    }
    
    return deferralMonthsKey;
}


const getKeyParamCard = (immCard) => {
    const isPack = immCard.get('isDiamond') || immCard.get('isPremium');
    return !isPack 
        ? 'open_credit'
        : (immCard.get('isDiamond') ? 'pack_diamond' : 'pack_premium');
}

const getTinAndTaeValues = (isLavandaFlow, chosenDeferral, immCard, parameters) => {
    const keyParam = getKeyParamCard(immCard);
    let tin = '-';
    let tae = '-';
    if(isLavandaFlow){
        if (!!chosenDeferral){
            if ( chosenDeferral === ONE_QUOTA){
                tin = formatText('lavanda-lavanda_oneQuotaTin');
                tae = formatText('lavanda-lavanda_oneQuotaTae');
            }else{
                tin = parameters && parameters.getIn([keyParam, PAY_LATER , TIN]);
                tae = parameters && parameters.getIn([keyParam, PAY_LATER , TAE]);
            }
        }
    }else {
        tin = parameters && parameters.getIn([keyParam, PAY_LATER , TIN]);
        tae = parameters && parameters.getIn([keyParam, PAY_LATER , TAE]);
    }
    return {[TIN]: tin, [TAE]: tae};
}

module.exports = {
    getChosenDeferralTag,
    getChosenDeferralText,
    getDeferralMonthsText,
    getDeferralOptionTag,
    getNumberOfQuotas,
    getKeyParamCard,
    getTinAndTaeValues,
    isLavandaCard,
}
